import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './style.css'
import _ from 'lodash'
import { Helmet } from 'react-helmet'
import NRTMasterSlave from '../../components/_common/_containers/MasterSlave'
import NRTPDF from "../../components/_ead/_contentTypes/PDF"
import ContentTitle from "../../components/_ead/ContentTitle"
import NRTQuestions from "../../components/_ead/_contentTypes/Questions"

import QuestionaryMainContainer from '../../components/_ead/_contentTypes/QuestionsNew/QuestionaryMainContainer'

import NRTEADVideo from "../../components/_ead/_contentTypes/Video"
import NRTListItem from "../../components/_common/ListItem"
import NRTToggleSwitch from "../../components/_common/_form/FormInput/ToggleSwitchInput"
import NRTCourseTrail from "../../components/_ead/CourseTrail"
import EadRequests from "../../requests/ead-requests"
import ReleaseRequests from "../../requests/release-requests"
import NRTHTML from "../../components/_ead/_contentTypes/HTML"
import NRTImage from "../../components/_ead/_contentTypes/Image"
import MCEadContentForumPost from "../../components/_ead/_contentTypes/ForumPost"
import NRTCourseSummary from "../../components/_ead/_contentTypes/CourseSummary"
import MCEADContentFile from "../../components/_ead/_contentTypes/File"
import MCLoading from "../../components/_minha-central/Loading"
import Lock from "../../components/_common/_icons/Lock";


async function getUserGradeOfModule(userCode, moduleCode) {

    const result = await EadRequests.searchUserForms({
        bestResults: true,
        usrCode: userCode,
        modCode: moduleCode,

    })


    const userForms = result.userform

    const grade = userForms ? userForms.map(f => f.grade * 100.0 / f.value).reduce((total, next) => total + next, 0) / userForms.length : 0

    return isNaN(grade) ? 0 : grade
}

class ModuleGrades {


    grades = {}

    addGrade = (moduleCode, grade) => {
        if (!this.grades[moduleCode]) {
            this.grades[moduleCode] = new UserGrade(0, grade)
        } else {
            this.grades[moduleCode].userGrade = grade
        }
    }

    changeMinPercentageApprovalOfModule = (moduleCode, minPercentageApproval) => {
        if (!this.grades[moduleCode]) {
            this.grades[moduleCode] = new UserGrade(minPercentageApproval)
        } else {
            this.grades[moduleCode].minPercentageApproval = minPercentageApproval
        }
    }


    hasUserBeenApprovedInModule(moduleCode) {
        const moduleGrades = this.grades[moduleCode]
        if (!moduleGrades) return true

        return moduleGrades.hasUserBeenApproved()
    }

    getModuleGrade(moduleCode) {
        return this.grades[moduleCode] || new UserGrade()
    }

}

class UserGrade {

    userGrade
    minPercentageApproval

    constructor (minPercentageApproval, userGrade = 0) {
        this.userGrade = userGrade
        this.minPercentageApproval = minPercentageApproval
    }

    hasUserBeenApproved = () => {
        return this.userGrade >= this.minPercentageApproval
    }
}


class EadWatchPage extends Component {

    static VIDEO_TYPE = 1
    sidebarRef = React.createRef()

    state = {
        contentsInOrder: [],
        currentContent: null,
        nextContent: null,
        prevContent: null,
        autoplay: true,
        modules: [],
        tracks: [],
        activeContentId: null,
        currentModuleApproval: null,
        windowWidth: null,
        moduleGrades: new ModuleGrades(),


        // lista de modulos aos quais o usuario nao pode acessar por nao ter passado na prova
        // dos modulos anteriores.
        cantAccessModuleCodes: []
    }


    componentDidMount() {
        const {
            accountCode,
            userId,
            releaseId,
            contentId,
        } = this.props.match.params

        const contextAccount = this.props.context.eadAccount



        if (!this.props.context.person)
            this.props.history.push('/')

        Promise
            .all([
                ReleaseRequests.oldSearch({ prlCode: releaseId }),
                EadRequests.searchEadUser({
                    usrCode: userId,
                }),
                EadRequests.searchEADModules({
                    prlCode: releaseId,
                    eadStatus: 1 // Published
                }),
                EadRequests.searchEadUserTrack({
                    usrCode: userId
                }),
                (!!contextAccount ? contextAccount : EadRequests.getAccount(accountCode))
            ])
            .then(results => {

                const searchRelease = results[0]
                const eadUser = results[1]
                const searchModules = results[2]
                const userTrackSearch = results[3]
                const account = results[4]
                const contentsInOrder = this.putContentsInOrder(searchModules, eadUser)

                // Atualiza state
                this.setState({
                    title: _.get(this.props, 'context.systemConfigParameterValue.title'),
                    modules: searchModules,
                    tracks: userTrackSearch,
                    release: searchRelease,
                    activeContentId: contentId,
                    userId,
                    releaseId,
                    accountCode,
                    contentsInOrder,
                    account,
                    eadUser
                }, async () => {

                    await this.updateBlockedModulesByGrade()


                    if (!contentId)
                        return

                    const module = this.getContentModule(searchModules, contentId)

                    const currentContentIndex = this.getIndexOfContent(contentId)
                    const currentContent = this.getContentOfIndex(currentContentIndex)
                    const tracks = await this.saveUserTrack(currentContent, userId, false)

                    this.setState({

                        currentContent,
                        nextContent: contentsInOrder[currentContentIndex + 1] || null,
                        prevContent: contentsInOrder[currentContentIndex - 1] || null,
                        currentModuleApproval: _.get(module, 'minPercentageApproved'),
                        tracks
                    })
                })
            })
            .catch(error => {
                this.onError(error, 'Ocorreu um erro ao inicializar EAD.', { method: 'componentDidMount()' })
            })

        this.updateWindowDimensions()
        document.addEventListener('resize', this.updateWindowDimensions);
        document.addEventListener('contextmenu', this._handleContextMenu);
    }


    async componentDidUpdate() {
        const {
            userId,
            contentId
        } = this.props.match.params

        const {
            contentsInOrder,
            activeContentId,
            currentContent
        } = this.state



        if (contentId !== activeContentId) {

            let tracks = this.state.tracks
            const contentIndex = this.getIndexOfContent(contentId)
            const nextContent = this.getContentOfIndex(contentIndex)


            if (!!nextContent) {

                if (currentContent && currentContent.code !== nextContent.code) {
                    tracks = await this.saveUserTrack(currentContent, userId, true)
                }

                tracks = await this.saveUserTrack(nextContent, userId, false)


            }


            const changeState = () => this.setState({
                activeContentId: contentId,
                currentContent: nextContent,
                nextContent: contentsInOrder[contentIndex + 1] || null,
                prevContent: contentsInOrder[contentIndex - 1] || null,
                tracks
            })

            if (
                _.get(currentContent, 'type') === EadWatchPage.VIDEO_TYPE &&
                _.get(nextContent, 'type') === EadWatchPage.VIDEO_TYPE
            ) {
                this.setState({ currentContent: null }, changeState) //faz refresh do conteudo de video...
            } else {
                changeState()
            }

        }

    }


    componentWillUnmount() {
        document.removeEventListener('resize', this.updateWindowDimensions);
        document.removeEventListener('contextmenu', this._handleContextMenu);
    }


    updateBlockedModulesByGrade = async () => {

        const { userId, } = this.props.match.params

        let userApprovedInModule = true
        const { moduleGrades } = this.state
        const cantAccessModuleCodes = []

        for (let m of this.state.modules) {

            if (!userApprovedInModule)
                cantAccessModuleCodes.push(m.code)

            if (!!m.minPercentageApproved) {
                moduleGrades.changeMinPercentageApprovalOfModule(m.code, m.minPercentageApproved)

                const userGrade = await getUserGradeOfModule(userId, m.code)

                moduleGrades.addGrade(m.code, userGrade)

                if (!moduleGrades.hasUserBeenApprovedInModule(m.code)) {
                    console.log('usuario nao aprovado no modulo ' + m.code)
                    userApprovedInModule = false
                }

            }
        }


        this.setState({ moduleGrades, cantAccessModuleCodes })

    }


    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth })
    }

    _handleContextMenu = (event) => {
        event.preventDefault()
    }


    getContentModule(modules, contentId) {
        let module = null
        modules.forEach(mod => {
            mod.classDTOs.forEach(cls => {
                if (cls.contentDTOs.map(cnt => cnt.code + '').includes(contentId)) {
                    module = mod
                }
            })
        })

        return module
    }

    putContentsInOrder(modules, user) {
        let x = 0, y = 0, z = 0
        const contentsInOrder = []
        modules.sort((a, b) => a.numOrder - b.numOrder).forEach(module => {
            module.classDTOs
                .sort((a, b) => a.numOrder - b.numOrder)
                .forEach(cls => {


                    cls.contentDTOs.sort((a, b) => a.numOrder - b.numOrder)
                        .forEach(content => contentsInOrder.push({
                            ...content,
                            modCode: module.code
                        }))

                    if (cls.contentDTOs.some(content => content.type !== 1)) {

                        //    console.log(contentsInOrder)
                        //se existit algum conteudo que nao e video
                        contentsInOrder.push({
                            type: 99,
                            typeSummary: 'class',
                            name: 'Resumo de aula',
                            code: 'a' + (x++),
                            clsCode: cls.code,
                            modCode: module.code,
                            contentName: cls.title,
                            user
                        })
                    }


                })
            contentsInOrder.push({
                type: 99,
                typeSummary: 'module',
                name: 'Resumo de módulo',
                code: 'b' + (y++),
                modCode: module.code,
                contentName: module.title,
                user
            })
        })

        const hasFinalContent = contentsInOrder.filter(cnt => cnt.lastContent).length > 0

        contentsInOrder.push({
            type: 99,
            typeSummary: 'course',
            name: 'Resumo de curso',
            code: 'c' + (z++),
            finished: hasFinalContent,
            user
        })

        return contentsInOrder
    }


    async saveUserTrack(content, userId, complete) {

        const _content = { ...content }
        delete _content.modCode

        let { tracks } = this.state

        if (!_content || _content.type === 99) {
            return tracks
        }

        if (!tracks || tracks.length === 0) {
            tracks = await EadRequests.searchEadUserTrack({
                usrCode: userId
            })
        }

        const result = tracks.filter((track) => track.contentCode === _content.code)
        // const result = tracks.filter(track => !!track.contentDTO && track.contentDTO.code === _content.code)

        let userTrack = {}

        // Se nao tem track ainda, cria um novo com status em progresso
        if (result.length === 0) {
            userTrack = {
                userDTO: this.state.eadUser,
                contentDTO: _content,
            }

        } else {
            userTrack = {
                code: result[0].code,
                userDTO: this.state.eadUser,
                contentDTO: _content,
                startDate: result[0].startDate
            }
            // userTrack = result[0]
        }

        const newStatus = complete ? 2 : 1

        if (userTrack.status === newStatus || userTrack.status === 2)
            return tracks

        userTrack.status = newStatus
        delete userTrack.statusEnum

        const saveResult = await EadRequests.saveUserTrack(userTrack)

        if (!saveResult.success) {
            console.log("erro ao criar track " + saveResult.errorMessages.join(","))
        } else {

            if (userTrack.code) {
                const index = tracks.indexOf(userTrack)
                tracks.splice(index, 1)
            }

            tracks.push(saveResult)
        }

        return tracks
    }


    getIndexOfContent(contentCode) {
        return _.findIndex(
            this.state.contentsInOrder,
            content => (content.code + '' === contentCode + '')
        )
    }


    getContentOfIndex(index) {
        return this.state.contentsInOrder[index]
    }


    toggleAutoPlay = () => {
        this.setState(state => ({
            autoplay: !state.autoplay
        }))
    }


    goToNextContent = () => {

        this.goToContent(this.state.nextContent.code)
    }

    goToPrevContent = () => this.goToContent(this.state.prevContent.code)
    contentClicked = (module, cls, content) => {
        this.goToContent(content.code)

        this.setState({
            currentModuleApproval: module.minPercentageApproved
        })
    }


    goToContent = (contentId) => {
        const {
            userId,
            releaseId,
            accountCode,
            windowWidth,
        } = this.state


        if (windowWidth < 900) {
            this.sidebarRef.current.collapseSlave()
        }

        this.props.history.push(`/ead/assistir/${accountCode}/${userId}/${releaseId}/${contentId}`)
    }


    onError = (error, errorMsg, data) => {

        this.setState({
            awaiting: false
        })

        this.props.context.logError(error, data)

        this.props.context.set({
            toastMessage: {
                type: 'error',
                content: errorMsg
            }
        })
    }

    setDisableSlaveAction = (value) => this.setState({ disableSlaveAction: value })

    render() {

        const {
            title,
            activeContentId,
            modules,
            tracks,
            release,
            currentContent,
            autoplay,
            cantAccessModuleCodes,
            disableSlaveAction
        } = this.state

        if (!title || !release || !this.state.moduleGrades)
            return <MCLoading />

        return (
            <div className={'nrt-app-container nrt-ead-watch-page'}>

                <NRTMasterSlave
                    ref={this.sidebarRef}
                    disableSlaveAction={disableSlaveAction}
                    slaveHeight={'calc(100vh - 4rem)'}
                    slave={
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <h3>{release.name}</h3>

                            <div className="settings">
                                <ul>
                                    <NRTListItem clickable={false}>
                                        Autoplay
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <span style={{ paddingRight: '0.5rem' }}>{autoplay ? 'ON' : 'OFF'}</span>
                                            <NRTToggleSwitch value={true}
                                                ref={'autoplaySwitch'}
                                                onChange={this.toggleAutoPlay}
                                            />
                                        </div>
                                    </NRTListItem>
                                </ul>
                            </div>

                            <NRTCourseTrail
                                activeContentId={parseInt(activeContentId)}
                                modules={modules}
                                userTracks={tracks}
                                onContentClick={this.contentClicked}
                                cantAccessModuleCodes={this.state.cantAccessModuleCodes}
                            />
                        </div>
                    }
                    onBackButtonClick={() => this.props.history.push('/conta/curso/' + this.props.match.params.accountCode)}

                    slaveClassNames={'trail'}

                    master={
                        <div className={'nrt-ead-watch-content-area'}>
                            <Helmet>
                                <meta charSet="utf-8" />
                                <title>{title} | {currentContent ? currentContent.name : ''} </title>
                            </Helmet>

                            {(
                                () => {

                                    if (!currentContent)
                                        return


                                    const content = currentContent


                                    if (cantAccessModuleCodes.indexOf(content.modCode) >= 0) {
                                        return (
                                            <div style={{
                                                display: 'flex',
                                                height: '100vh',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                flexDirection: 'column'
                                            }}>

                                                <Lock style={{ marginBottom: '1.5rem', opacity: .6, width: '6rem' }} />
                                                <h3>Você ainda não possui a pontuação necessária para visualizar este
                                                    conteúdo.</h3>
                                            </div>
                                        )
                                    }


                                    const {
                                        prevContent,
                                        nextContent,
                                        eadUser,
                                        currentModuleApproval,
                                        account
                                    } = this.state


                                    let blockNextContentButton = false
                                    if (content.typeSummary === 'module') {
                                        blockNextContentButton = !this.state.moduleGrades.hasUserBeenApprovedInModule(content.modCode)
                                    }


                                    const contentTitle = (
                                        <ContentTitle
                                            prevContent={prevContent}
                                            nextContent={nextContent}
                                            onPrevContentButtonClick={this.goToPrevContent}
                                            onNextContentButtonClick={this.goToNextContent}
                                            title={content.name}
                                            blockNextContentButton={blockNextContentButton}
                                        />
                                    )

                                    switch (content.type) {
                                        case EadWatchPage.VIDEO_TYPE: //VIDEO
                                            return (
                                                <div style={{ background: 'black', height: '100vh' }}>
                                                    <NRTEADVideo
                                                        section={content.breadcrumb}
                                                        title={content.name}
                                                        autoplay={autoplay}
                                                        videoSrc={content.content}
                                                        prevContent={prevContent}
                                                        nextContent={nextContent}
                                                        onNextContentClick={this.goToNextContent}
                                                        onPrevContentClick={this.goToPrevContent}
                                                        context={this.props.context}
                                                    />
                                                </div>
                                            )
                                        case 2: //IMAGEM
                                            return (
                                                <div>
                                                    {contentTitle}
                                                    <div className={'content-body'}>
                                                        <NRTImage url={content.content}
                                                            context={this.props.context}
                                                        />
                                                    </div>
                                                </div>)
                                        case 3: //HTML
                                            return (
                                                <div>
                                                    {contentTitle}
                                                    <div className={'content-body'}>
                                                        <NRTHTML htmlContent={content.content}
                                                            context={this.props.context}
                                                        />
                                                    </div>
                                                </div>
                                            )
                                        case 4: //PDF
                                            return (
                                                <div>
                                                    {contentTitle}

                                                    <NRTPDF title={'Conteúdo PDF'}
                                                        url={content.content}
                                                        onNextButtonClick={nextContent ? this.goToNextContent : null}
                                                        onPrevButtonClick={prevContent ? this.goToPrevContent : null}
                                                        context={this.props.context}
                                                    />

                                                </div>
                                            )
                                        case 5: //SIMULADO
                                            const isPractice = content.formDTO.mock


                                            if (isPractice) {
                                                return (
                                                    <div>

                                                        <div className={'content-questions'}>
                                                            <QuestionaryMainContainer
                                                                updateSlaveAction={this.setDisableSlaveAction}
                                                                form={content.formDTO}
                                                                eadUser={eadUser}
                                                                context={this.props.context}
                                                                onQuestionAnswersSent={this.updateBlockedModulesByGrade}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            } else {
                                                return (
                                                    // QUESTIONARIO VERSAO ANTIGA
                                                    <div>
                                                        {contentTitle}
                                                        <div className={'content-body'}>

                                                            {<NRTQuestions form={content.formDTO}
                                                                eadUser={eadUser}
                                                                context={this.props.context}
                                                                onQuestionAnswersSent={this.updateBlockedModulesByGrade}
                                                            />
                                                            }

                                                        </div>
                                                    </div>
                                                )
                                            }

                                        case 6: //UPLOAD
                                            return (
                                                <div>
                                                    {contentTitle}
                                                    <div className={'content-body'}>
                                                        <MCEADContentFile
                                                            release={release}
                                                            hasTutor={content.hasTutor}
                                                            maxTutorDate={content.maxTutorDate}
                                                            cntCode={content.code}
                                                            message={content.content}
                                                            context={this.props.context}
                                                            onError={this.onError}
                                                        />
                                                    </div>
                                                </div>
                                            )
                                        case 7: //FORUM
                                            return (
                                                <div>
                                                    {contentTitle}
                                                    <div className={'content-body'}>
                                                        <MCEadContentForumPost
                                                            message={content.content}
                                                            cntCode={content.code}
                                                            context={this.props.context}
                                                            onError={this.onError}
                                                        />
                                                    </div>
                                                </div>
                                            )
                                        case 99: //RESUMO DE AULA, MODULO, CURSO
                                            return (
                                                <div>
                                                    {contentTitle}
                                                    <div className={'content-body'}>
                                                        <NRTCourseSummary
                                                            {...content}
                                                            history={this.props.history}
                                                            code={account.code}
                                                            release={this.state.release}
                                                            nextContentSumary={nextContent}
                                                            onNextContentButtonSumary={this.goToNextContent}
                                                            context={this.props.context}
                                                            grades={this.state.moduleGrades}
                                                            accountCode={this.state.accountCode}
                                                        />
                                                    </div>
                                                </div>
                                            )

                                        default:
                                            return null

                                    }

                                }
                            )
                                ()}
                        </div>
                    }
                />
            </div>
        )
    }
}


EadWatchPage.propTypes = {
    history: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
}

EadWatchPage.defaultProps = {}

export default EadWatchPage



// WEBPACK FOOTER //
// ./src/_pages/Watch/index.js